/**
 * Input component script class
 *
 * @package    Common
 * @author     Vadym Karpenko <vkarpenko@mindk.com>
 * @copyright  Copyright (c) 2010-2018 MindK (http://mindk.com). All rights reserved.
 * @license    http://mindk.com
 * @link       http://mindk.com
 */

import React, { Component } from 'react';
import PropTypes from 'prop-types';

export default class TextareaInput extends Component {
    /**
     * @type {Object}
     */
    static propTypes = {
        type: PropTypes.string,
    };

    render() {
        return (<textarea { ...this.props }/>);
    }
}



// WEBPACK FOOTER //
// ./src/common/Form/TextareaInput.jsx